import { EditButton, ReferenceField, Show, SimpleShowLayout, TextField } from "react-admin";
import { Grid, useMediaQuery } from "@mui/material";
import { settings } from "app";
import permissions from "app/permissions";
import BackButtonToolbar from "features/BackButtonToolbar";
import SecuredComponent from "server/security/SecuredComponent";
import { administrationRequests } from "api/administrationApi";
import { MOBILE_BREAKPOINT } from "utils/constants";

const ShowUniversityForm = () => {
  const isMobile = useMediaQuery(MOBILE_BREAKPOINT);

  return (
    <Show
      title="Детайли за университет"
      actions={
        <BackButtonToolbar
          additionalButton={
            <SecuredComponent permission={permissions.canManageExternalUniversities}>
              <EditButton
                variant="contained"
                size="medium"
              />
            </SecuredComponent>
          }
        />
      }
    >
      <Grid
        container
        spacing={2}
        gap={2}
        sx={isMobile ? settings.style.shadowBoxMobile : settings.style.shadowBox}
      >
        <Grid
          item
          xs={12}
        >
          <SimpleShowLayout>
            <TextField
              label="Име на Университет"
              source="name"
            />
            <ReferenceField
              label="Държава"
              source="countryId"
              reference={administrationRequests.getCountriesSelect()}
            >
              <TextField source="nameBg" />
            </ReferenceField>
            <TextField
              label="Град"
              source="city"
            />
            <TextField
              label="Работен език"
              source="workingLanguage"
            />
            <TextField
              label="Еразъм код"
              source="erasmusCode"
            />
            <TextField
              label="Линк"
              source="websiteLink"
            />
            <TextField
              label="Контакти"
              source="contact"
            />
            <TextField
              label="Имейл"
              source="email"
            />
          </SimpleShowLayout>
        </Grid>
      </Grid>
    </Show>
  );
};

export default ShowUniversityForm;
